import script from "./MayoresVisorMapa.vue?vue&type=script&setup=true&lang=js"
export * from "./MayoresVisorMapa.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__